import React from 'react';
import parse from 'html-react-parser';
import { Svg } from '../../1_Atoms/Svg/Svg';
import Button from '../../1_Atoms/Button/Button';

interface FormConfirmationProps {
  heading: string;
  subHeading?: string;
  firstName?: string;
  isDark?: boolean;
  onClick?: () => void;
  buttonLabel?: string;
}

const FormConfirmation: React.FC<FormConfirmationProps> = ({
  heading,
  subHeading = '',
  firstName,
  isDark = false,
  onClick,
  buttonLabel,
}) => {
  const parseSub = firstName && typeof firstName === 'string' 
    ? subHeading.replace('|firstName|', firstName) 
    : subHeading;

  return (
    <div className={`mz-form-confirmation ${isDark ? 'mz-form-confirmation--dark' : ''}`}>
      <Svg
        type="checkmark"
        size={3}
        colour={isDark ? 'white' : 'black'}
      />
      <h3>{parse(heading)}</h3>
      <div className="paragraph">{parse(parseSub)}</div>
      {buttonLabel ? (
        <Button
          type="submit"
          className={`mz-btn--secondary ${isDark ? 'mz-btn--black' : ''}`}
          label={buttonLabel}
          onClick={onClick}
        />
      ) : ''}
    </div>
  );
};

export default FormConfirmation;
